// react
import { useState, useEffect, useContext } from "react";

// components
import Counter from "../counter/Counter";
import { Heading } from "../heading/Heading";
import { Copy } from "../copy/Copy";
import Shelf from "../shelf/shelf.component";
import Button from "../button/Button";
import TypeAhead from "../typeahead/typeahead";
import FormControl from "../formControl/FormControl";
import FormLabel from "../formLabel/FormLabel";
import ErrorMessage from "../errorMessage/ErrorMessage";

// context
import InitialContext from "../../context/InitialContext";
import ProductContext from "../../context/ProductContext";

// styles
import "./searchForm.styles.scss";

// Parent: InventorySearchForm.tsx
// we aren't using invalid input state yet. commented out state and function would make them work
function SearchForm(
  { productNumberParent }: { productNumberParent: any },
  props: any,
) {
  // context
  const initialContext: any = useContext(InitialContext);
  const productContext: any = useContext(ProductContext);

  const {
    productDispatch,
    productState: { ProductNumber },
  }: {
    productDispatch: any;
    productState: {
      ProductNumber: string;
      Quantity: string;
      isSubmitted: boolean;
    };
  } = productContext;

  const {
    initialState: {
      data: { BodyHeadline, BodyCopy },
    },
  }: {
    initialState: {
      data: { BodyHeadline: string; BodyCopy: string };
    };
  } = initialContext;

  // locally scoped hooks
  const [invalid, setInvalid] = useState(false);
  const [isFirstRun, setIsFirstRun] = useState(true);

  const onSubmitHandler = () =>
    productDispatch({
      type: "SET_SUBMITTED",
      payload: true,
    });

  useEffect(() => {
    "" === ProductNumber && !isFirstRun ? setInvalid(true) : setInvalid(false);
    setIsFirstRun(false);
  }, [ProductNumber]);

  const handleCounterChange = (count: string) =>
    productDispatch({
      type: "SET_COUNTER_QUANTITY",
      payload: count,
    });

  const productNumberContext = (product: string) =>
    productNumberParent(product);

  const handleInputChange = (productNumber?: string) => {
    if (productNumber) {
      const valueWithSpacesTrimmed = productNumber.trim();
      productNumberContext(valueWithSpacesTrimmed);
    }
  };

  const onSearchBoxKeyPress = (e: any) => {
    if (e && e.key === "Enter") {
      onSubmitHandler();
    }
  };

  const getProductFromQueryString = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    productNumberContext(params.sku ?? "");
  };

  useEffect(() => {
    getProductFromQueryString();
  }, []);

  // useEffect(() => {
  //   console.log('productNumber changed', productNumber)
  // }, [productNumber]);

  return (
    <>
      <div className="box">
        <Shelf mobile="15" tablet="10" desktop="10">
          <Heading className={"hdg hdg_h5 hdg_neutral"} element="h3" {...props}>
            {BodyHeadline}
          </Heading>
        </Shelf>

        <Shelf mobile="15" tablet="30" desktop="40">
          <Copy className={"copy"} {...props}>
            {BodyCopy}
          </Copy>
        </Shelf>

        <div className="grid">
          <Shelf mobile="20" tablet="0" desktop="0">
            <FormControl isInvalid={invalid}>
              <Shelf mobile="3" tablet="3" desktop="3">
                <FormLabel
                  isInvalid={invalid}
                  labelIdentifier="product-number"
                  isRequired
                >
                  Product Number
                </FormLabel>
              </Shelf>
              <TypeAhead
                initialValue={ProductNumber}
                productNumberContext={productNumberContext}
                onInputChange={handleInputChange}
                placeholder="Product Number"
                isInvalid={invalid}
              />
              {invalid && <ErrorMessage />}
            </FormControl>
          </Shelf>
          <Shelf mobile="40" tablet="0" desktop="0">
            <FormControl>
              <Shelf mobile="3" tablet="3" desktop="3">
                <FormLabel labelIdentifier="quantity">Quantity</FormLabel>
              </Shelf>
              <Counter
                min={1}
                max={999_999}
                onCountChanged={handleCounterChange}
                onKeyPress={onSearchBoxKeyPress}
              />
            </FormControl>
          </Shelf>
          <Shelf mobile="0" tablet="0" desktop="0">
            <div className="searchForm-buttonSpacer">
              <FormControl>
                <Button onClick={onSubmitHandler}>Check Now</Button>
              </FormControl>
            </div>
          </Shelf>
        </div>
      </div>
    </>
  );
}

export default SearchForm;
